import { JobCountResponse } from '@doda/api-client/aspida/@types';
import {
  JobCountQuery,
  getJobCount,
} from '@doda/common/src/services/getJobCountAPI';
import { removeUndefinedFromObject } from '@doda/common/src/utils/objectUtil';
import { SelectedCurrentConditionType } from 'types/searchCondition';
import { useState } from 'react';

/**
 * 実行することで、各条件による求人件数を取得するためのカスタムフック
 *
 * @param {SelectedCurrentConditionType} selectedCurrentCondition - 現在選択されている検索条件
 * @returns {object} 各条件の求人件数と、求人件数を取得するための関数群
 */
export const useEachModalJobCount = (
  selectedCurrentCondition: SelectedCurrentConditionType
) => {
  // 職種以外の設定条件で求人件数を取得
  const [occupationModalJobCount, setOccupationModalJobCount] =
    useState<JobCountResponse>({});
  const getJobCountWithoutOccupation = async () => {
    const conditions: JobCountQuery = {
      ...selectedCurrentCondition,
      searchJobTypeLId: [],
      searchJobTypeMId: [],
      searchJobTypeSId: [],
    };
    const res = await getJobCount(removeUndefinedFromObject(conditions));
    setOccupationModalJobCount(res);
  };

  // 勤務地、路線・駅以外の設定条件で求人件数を取得
  const [locationAndStationModalJobCount, setLocationAndStationModalJobCount] =
    useState<JobCountResponse>({});
  const getJobCountWithoutLocationAndStation = async () => {
    const conditions: JobCountQuery = {
      ...selectedCurrentCondition,
      areaId: [],
      prefectureId: [],
      cityId: [],
      wardId: [],
      routeId: [],
      stationId: [],
    };
    const res = await getJobCount(removeUndefinedFromObject(conditions));
    setLocationAndStationModalJobCount(res);
  };

  // 業種以外の設定条件で求人件数を取得
  const [industryModalJobCount, setIndustryModalJobCount] =
    useState<JobCountResponse>({});
  const getJobCountWithoutIndustry = async () => {
    const conditions: JobCountQuery = {
      ...selectedCurrentCondition,
      industryLId: [],
      industrySId: [],
    };
    const res = await getJobCount(removeUndefinedFromObject(conditions));
    setIndustryModalJobCount(res);
  };

  return {
    occupationModalJobCount,
    locationAndStationModalJobCount,
    industryModalJobCount,
    getJobCountWithoutOccupation,
    getJobCountWithoutLocationAndStation,
    getJobCountWithoutIndustry,
  };
};
